import React, { Component } from "react";

import {
  ContactVerkoop,
  ContactLeveranciers,
  ContactStudenten,
  ContactSolliciteren,
} from "../../assets/images/index.js";
import Swiper from "swiper";
import ContactTab from "./ContactTab";
import { I18n } from "react-i18next";
import i18n from "../../i18n";

import Verkoop from "assets/images/Contact/01_Verkoop/Salesteam.jpg";
import Leveranciers from "assets/images/Contact/02_Toeleveranciers/renata-stickeren.jpg";
import Student from "assets/images/Contact/03_Studenten/contact-student-docent.jpg";
import Solliciteren from "assets/images/Contact/04_Solliciteren/contact-solliciteren.jpg";

export default class ContactTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addClass1: true,
      addClass2: false,
      addClass3: false,
      addClass4: false,
    };
    window.addEventListener("load", this.handleLoad);
  }
  componentDidMount() {
    new Swiper(".contact__tab-swiper", {
      speed: 400,
      slidesPerView: "auto",
      watchSlidesVisibility: true,
      slideClass: "contact__tab-option",
      allowTouchMove: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function () {
          if (window.innerWidth >= 768) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
            this.slideTo(0);
          }
          this.update();
        },
        resize: function () {
          if (window.innerWidth >= 768) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
            this.slideTo(0);
          }
          this.update();
        },
      },
    });
  }
  toggle1() {
    this.setState({ addClass2: false });
    this.setState({ addClass3: false });
    this.setState({ addClass4: false });
    this.setState({ addClass1: true });
  }
  toggle2() {
    this.setState({ addClass1: false });
    this.setState({ addClass3: false });
    this.setState({ addClass4: false });
    this.setState({ addClass2: true });
  }
  toggle3() {
    this.setState({ addClass1: false });
    this.setState({ addClass2: false });
    this.setState({ addClass4: false });
    this.setState({ addClass3: true });
  }
  toggle4() {
    this.setState({ addClass1: false });
    this.setState({ addClass2: false });
    this.setState({ addClass3: false });
    this.setState({ addClass4: true });
  }
  handleLoad() {
    let hash = window.location.hash;
    // console.log(hash);
    if (hash === "#contactTabs") {
      const ele = document.getElementById("contactTabs");
      // console.log(ele.offsetTop);
      window.scrollTo(ele.offsetLeft, ele.offsetTop);
      setTimeout(function () {
        window.scrollTo(0, 600);
        this.toggle4;
      }, 2);
    }
  }
  render() {
    let activeClass1 = ["contact__tab-option"];
    let activeClass2 = ["contact__tab-option"];
    let activeClass3 = ["contact__tab-option"];
    let activeClass4 = ["contact__tab-option"];
    if (this.state.addClass1) {
      activeClass1.push("is-active");
    }
    if (this.state.addClass2) {
      activeClass2.push("is-active");
    }
    if (this.state.addClass3) {
      activeClass3.push("is-active");
    }
    if (this.state.addClass4) {
      activeClass4.push("is-active");
    }
    return (
      <I18n>
        {(t, { i18n }) => (
          <div className="contact__tab-container">
            <div className="contact__tab-swiper swiper-container">
              <ul
                className="contact__tab-selector swiper-wrapper mt30"
                id="contactTabs"
              >
                <li
                  onClick={this.toggle1.bind(this)}
                  className={activeClass1.join(" ") + " flex flex-column"}
                >
                  <ContactVerkoop />
                  <span>{t("contactTabsSales")}</span>
                </li>
                <li
                  onClick={this.toggle2.bind(this)}
                  className={activeClass2.join(" ") + " flex flex-column"}
                >
                  <ContactLeveranciers />
                  <span>{t("contactTabsSuppliers")}</span>
                </li>
                <li
                  onClick={this.toggle3.bind(this)}
                  className={activeClass3.join(" ") + " flex flex-column"}
                >
                  <ContactStudenten />
                  <span>{t("contactTabsSalesEducation")}</span>
                </li>
                <li
                  onClick={this.toggle4.bind(this)}
                  className={activeClass4.join(" ") + " flex flex-column"}
                >
                  <ContactSolliciteren />
                  <span>{t("contactTabsSalesApplying")}</span>
                </li>
              </ul>
              <div className="swiper-button-container">
                <div className="swiper-button-prev">
                  <span />
                  <span />
                  <span />
                </div>
                <div className="swiper-button-next">
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            </div>
            <div className="contact__tab-content-container mt40">
              <ContactTab
                tabId="1"
                extraClasses={activeClass1.join(" ")}
                department={t("contactTabSales")}
                departmentDescription={t("contactTabDescription1")}
                name1="Richard Visser"
                email1="sales@foreverplants.nl"
                phone1="0174 - 622 668"
                name2="Corné van Winden"
                email2="sales@foreverplants.nl"
                phone2="0174 - 622 668"
                image={Verkoop}
              />
              <ContactTab
                tabId="2"
                extraClasses={activeClass2.join(" ")}
                department={t("contactTabDelivery")}
                departmentDescription={t("contactTabDescription2")}
                name1="Thom Persoon"
                email1="thom@foreverplants.nl"
                phone1="0174 - 629 688"
                name2="Mart van Holsteijn"
                email2="mart@foreverplants.nl"
                phone2="0174 - 629 688"
                name3="Leon van der Valk"
                email3="leon@foreverplants.nl"
                phone3="0174 - 629 688"
                image={Leveranciers}
              />
              <ContactTab
                tabId="3"
                extraClasses={activeClass3.join(" ")}
                department={t("contactTabEducation")}
                departmentDescription={t("contactTabDescription3")}
                name1="Thom Persoon"
                email1="hallo@foreverplants.nl"
                phone1="0174 - 629 688"
                image={Student}
              />
              <ContactTab
                tabId="4"
                extraClasses={activeClass4.join(" ")}
                department={t("contactTabApply")}
                departmentSub="Monique Persoon"
                departmentDescription={t("contactTabDescription4")}
                email1="solliciteren@foreverplants.nl"
                phone1="0174 - 629 688"
                image={Solliciteren}
              />
            </div>
          </div>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactCategories/Contact.jsx